/**
 * Makes a whole .hero__block clickable when it contains exactly one link,
 * navigating to that link. With more than one link, the block stays
 * inert and the user must click the individual buttons/links.
 */
const makeSingleLinkHeroWrapperClickable = () => {
    document.querySelectorAll('.hero__block').forEach((block) => {
        const links = block.querySelectorAll('a');
        if (links.length !== 1) return;

        const link = links[0];
        block.style.cursor = 'pointer';
        block.addEventListener('click', (e) => {
            if (e.target.closest('a')) return;
            window.location.href = link.href;
        });
    });
};

window.setTimeout(() => {
    makeSingleLinkHeroWrapperClickable();
}, 1500);
